import { LupaIcon } from "assets/icons/LupaIcon";
import { showErrorToast } from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { Pagination } from "components/Pagination/Pagination";
import { DEFAULT_LIMIT_PAGINATION } from "constants/appConstants";
import { useFormik } from "formik";
import { TipoEspacioI } from "interfaces/TipoEspacio";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getTipoEspacio } from "services/tipoEspacio";
import { AppDispatch, RootState } from "store/store";
import { TipoEspacioRowActions } from "./TipoEspacioTable/TipoEspacioRowActions";
import { TipoEspacioABM } from "./TipoEspacioABM/TipoEspacioABM";
import { TipoEspacioTable } from "./TipoEspacioTable/TipoEspacioTable";

export const TipoEspacio = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [elementos, setElementos] = useState<TipoEspacioI[]>();
  const [cantidad, setCantidad] = useState<number>();
  const [page, setPage] = useState<number>();
  const [limit, setLimit] = useState<number>();

  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { tiposNormativa, tiposEfecto, loadingAppData } = useSelector(
    (st: RootState) => st.appData,
  );

  const [showModalABM, setShowModalABM] = useState(false);
  const [actionType, setActionType] = useState<"create" | "edit" | undefined>();
  const [selectedElement, setSelectedElement] = useState<
    TipoEspacioI | undefined
  >();

  const initialValues = {
    id: "",
    nombre: "",
  };

  const { values, handleChange, resetForm } = useFormik({
    initialValues,
    onSubmit: () => {},
  });

  const searchTipoEspacio = async (params?: {
    filtros?: { [key: string]: any };
  }) => {
    try {
      setIsLoading(true);
      const response = await getTipoEspacio({ ...params?.filtros });
      setElementos(response.elementos);
      setCantidad(response.cantidad);
      setPage(response.page);
      setLimit(params?.filtros?.limit ?? DEFAULT_LIMIT_PAGINATION);
    } catch (err) {
      showErrorToast("No fue posible cargar los tipo de espacio");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModalABM(false);
    setTimeout(() => setActionType(undefined), 500);
  };

  const handleEdit = (elemento: TipoEspacioI) => {
    setActionType("edit");
    setSelectedElement(elemento);
    setShowModalABM(true);
  };

  const handleCreate = () => {
    setActionType("create");
    setShowModalABM(true);
  };

  const handleChangePagination = (newFiltros: {
    [key: string]: string | number;
  }) => {
    searchTipoEspacio({ filtros: { ...values, ...newFiltros } });
  };

  const handleClearFilters = () => {
    resetForm();
    searchTipoEspacio();
  };

  const handleChangeWithResetPage = (pageOne: any) => {
    setPage(1);
    handleChange(pageOne);
  };

  const refreshTable = () => {
    setPage(1);
    searchTipoEspacio({ filtros: { ...values, page: 1 } });
  };

  const renderActions = (elemento: TipoEspacioI) => {
    return (
      <TipoEspacioRowActions
        elemento={elemento}
        onClickEdit={handleEdit}
        refreshTable={refreshTable}
      />
    );
  };

  useEffect(() => {
    searchTipoEspacio({ filtros: { ...values, limit, page } });
  }, [values]);

  return (
    <section>
      <h1 className="section-title">Tipo de Espacio</h1>

      <h2 className="section-subtitle mt-2">
        Desde aquí podrás gestionar los tipos de espacio.
      </h2>

      <div className="d-flex justify-content-between mt-4 mb-3">
        <div className="d-flex column-gap-3">
          <Input
            size="sm"
            id="nombre"
            onChange={handleChangeWithResetPage}
            placeholder="Buscar"
            values={values}
            startIcon={<LupaIcon />}
          />
          <Button
            size="sm"
            variant="secondary"
            className="clear-filters-button"
            onClick={handleClearFilters}
            disabled={!values.nombre}
          >
            Limpiar filtros
          </Button>
        </div>
        <Button size="lg" onClick={handleCreate}>
          Nuevo Tipo de Espacio
        </Button>
        <TipoEspacioABM
          showModal={showModalABM}
          actionType={actionType}
          onClose={handleCloseModal}
          elemento={selectedElement}
          onSuccess={refreshTable}
        />
      </div>

      {isLoading && (
        <div className="d-flex justify-content-center w-full">
          <Spinner />
        </div>
      )}

      {!isLoading && elementos && cantidad != undefined && (
        <>
          <TipoEspacioTable
            elementos={elementos}
            renderActions={renderActions}
          />
          <Pagination
            totalItems={cantidad}
            currentPage={page}
            currentLimit={limit}
            onChangePage={handleChangePagination}
            showPaginationOnlyOnMoreThanPages={1}
          />
        </>
      )}
    </section>
  );
};
